import { msg } from "@lingui/core/macro";
import { Trans, useLingui } from "@lingui/react/macro";

import { useRankLookup } from "../../api/useRankLookup";
import { rankSteps } from "../../lib/rankSteps";
import { SummaryTile } from "./SummaryTile";

const UP = msg({
  message: "{steps, plural, one {Up # subrank this week} other {Up # subranks this week}}",
});
const DOWN = msg({
  message: "{steps, plural, one {Down # subrank this week} other {Down # subranks this week}}",
});

type RankTileProps = {
  badge: number;
  // Ранг после последнего рейтингового матча неделю назад; таких матчей нет — `null`.
  weekAgo: number | null;
};

// Плитка «Ранг»: ранг после последнего рейтингового матча и как он изменился за неделю.
export const RankTile = ({ badge, weekAgo }: RankTileProps) => {
  const { i18n } = useLingui();
  const rank = useRankLookup()(badge);
  const steps = weekAgo === null ? null : rankSteps(weekAgo, badge);
  const details =
    steps === null ? undefined : steps === 0 ? (
      <Trans>No change this week</Trans>
    ) : (
      i18n._({ ...(steps > 0 ? UP : DOWN), values: { steps: Math.abs(steps) } })
    );
  return (
    <SummaryTile
      severity={steps !== null && steps < 0 ? "bad" : "good"}
      label={<Trans>Rank</Trans>}
      value={rank.name}
      details={details}
    />
  );
};
